module.exports = __webpack_public_path__ + "img/banner_tayaya.6428c848.jpg";